import { render } from "./PCLogisticExistenceLocation.vue?vue&type=template&id=643ed66c"
import script from "./PCLogisticExistenceLocation.vue?vue&type=script&lang=js"
export * from "./PCLogisticExistenceLocation.vue?vue&type=script&lang=js"

import "./PCLogisticExistenceLocation.vue?vue&type=style&index=0&id=643ed66c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__